/* eslint-disable import/first */
/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "core-js/stable";
import "regenerator-runtime/runtime";

// Polyfills
import "@stimulus/polyfills";
import "polyfills/ParentNode-append";
import "custom-event-polyfill";
import "intersection-observer";

require("../initializers/setup_sentry");

import { registerLocale, setDefaultLocale } from "react-datepicker";
import pt from "date-fns/locale/pt";
import de from "date-fns/locale/de";

registerLocale("pt", pt);
registerLocale("de", de);
setDefaultLocale(I18n.locale);

// eslint-disable-next-line no-multi-assign
global.$ = global.jQuery = require("jquery");
require("jquery-ujs");

global.$.ajaxSetup({
  headers: {
    "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
  },
});

// Use this to show XXX instead of a translation.
// Show the translation key instead of XXX if the
//   key is missing in .yml file.
//
// const realI18n = window.I18n;
// window.I18n = {};
// window.I18n.t = (foo, bar) => {
//   if (realI18n.lookup(foo)) {
//     return 'XXX';
//   }

//   return foo;
// };

// Stimulus.js;
import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";

const Turbolinks = require("turbolinks");

Turbolinks.start();

const application = Application.start();
const context = require.context("../controllers", true, /\.js$/);
application.load(definitionsFromContext(context));
// Stimulus.js

// Custom export from getbootstrap.com
// require('bootstrap');
require("../vendor/bootstrap/modals");
require("../vendor/bootstrap/collapse");

require("@fancyapps/fancybox");
require("@fancyapps/fancybox/src/css/core.css");

$.fancybox.defaults.hash = false;

// Don't include stories in application build
const componentRequireContext = require.context("components", true);
const ReactRailsUJS = require("react_ujs");

ReactRailsUJS.useContext(componentRequireContext);

require("../initializers/slider");
require("../initializers/sidebar");
require("../initializers/setup_dropzone");
require("../initializers/setup_see_more");
require("../initializers/character_counter");
require("../initializers/setup_review_modal");
require("../initializers/setup_search_tag_gtm");
require("../initializers/setup_onboard_overlay");
require("../initializers/setup_object_fit_images");
require("../initializers/setup_discover_more_gtm");
require("../initializers/setup_language_link_click");
require("../initializers/setup_collapsable_content");
require("../initializers/setup_blur_input_on_scroll");
require("../initializers/setup_forwarded_inquiry_rejection_survey");
require("../initializers/setup_turbolinks_hashtag_in_url_compatibility");
require("../initializers/setup_cookies_bar");
require("../initializers/setup_faq");
require("../initializers/setup_lozad");
require("../initializers/setup_client_id_tracking");
require("../initializers/setup_smart_inquiry");
require("../initializers/setup_job_posting");
require("../initializers/setup_lazy_react_components");
require("../initializers/setup_identity");
require("../initializers/setup_dashboard_analytics");

// Trix and ActionText for rich text editing (used in CMS)
const Trix = require("trix");

// Expose Trix to window for debugging (remove in production if desired)
if (typeof window !== "undefined") {
  window.Trix = Trix;
}

// Set custom toolbar config immediately after Trix loads (before editors are created)
// This must happen before require("@rails/actiontext") and before any trix-editor elements exist
const { lang } = Trix.config;
Trix.config.toolbar = {
  getDefaultHTML() {
    return `
    <div class="trix-button-row">
      <span class="trix-button-group trix-button-group--text-tools" data-trix-button-group="text-tools">
        <button type="button" class="trix-button trix-button--icon trix-button--icon-bold" data-trix-attribute="bold" data-trix-key="b" title="${lang.bold}" tabindex="-1">${lang.bold}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-italic" data-trix-attribute="italic" data-trix-key="i" title="${lang.italic}" tabindex="-1">${lang.italic}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-strike" data-trix-attribute="strike" title="${lang.strike}" tabindex="-1">${lang.strike}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-link" data-trix-attribute="href" data-trix-action="link" data-trix-key="k" title="${lang.link}" tabindex="-1">${lang.link}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-embed" data-trix-attribute="embed" data-trix-action="embed-html" data-trix-key="k" title="Embed Html" tabindex="-1">Embed Html</button>
      </span>
      <span class="trix-button-group trix-button-group--block-tools" data-trix-button-group="block-tools">
        <button type="button" class="trix-button trix-button--icon trix-button--icon-heading-1" data-trix-attribute="heading1" title="${lang.heading1}" tabindex="-1">${lang.heading1}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-quote" data-trix-attribute="quote" title="${lang.quote}" tabindex="-1">${lang.quote}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-code" data-trix-attribute="code" title="${lang.code}" tabindex="-1">${lang.code}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-bullet-list" data-trix-attribute="bullet" title="${lang.bullets}" tabindex="-1">${lang.bullets}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-number-list" data-trix-attribute="number" title="${lang.numbers}" tabindex="-1">${lang.numbers}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-decrease-nesting-level" data-trix-action="decreaseNestingLevel" title="${lang.outdent}" tabindex="-1">${lang.outdent}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-increase-nesting-level" data-trix-action="increaseNestingLevel" title="${lang.indent}" tabindex="-1">${lang.indent}</button>
      </span>
      <span class="trix-button-group trix-button-group--file-tools" data-trix-button-group="file-tools">
        <button type="button" class="trix-button trix-button--icon trix-button--icon-attach" data-trix-action="attachFiles" title="${lang.attachFiles}" tabindex="-1">${lang.attachFiles}</button>
        <button type="button" class="trix-button" data-trix-action="insert-module" title="Insert Module" tabindex="-1">+ Module</button>
      </span>
      <span class="trix-button-group-spacer"></span>
      <span class="trix-button-group trix-button-group--history-tools" data-trix-button-group="history-tools">
        <button type="button" class="trix-button trix-button--icon trix-button--icon-undo" data-trix-action="undo" data-trix-key="z" title="${lang.undo}" tabindex="-1">${lang.undo}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-redo" data-trix-action="redo" data-trix-key="shift+z" title="${lang.redo}" tabindex="-1">${lang.redo}</button>
      </span>
    </div>
    <div class="trix-dialogs" data-trix-dialogs>
      <div class="trix-dialog trix-dialog--link" data-trix-dialog="href" data-trix-dialog-attribute="href">
        <div class="trix-dialog__link-fields">
          <input type="url" name="href" class="trix-input trix-input--dialog" placeholder="${lang.urlPlaceholder}" aria-label="${lang.url}" required data-trix-input>
          <div class="flex">
            <input type="button" class="btn btn-secondary btn-small mr-1" value="${lang.link}" data-trix-method="setAttribute">
            <input type="button" class="btn btn-tertiary outline btn-small" value="${lang.unlink}" data-trix-method="removeAttribute">
          </div>
        </div>
        <div data-behavior="embed_container">
          <div class="link_to_embed link_to_embed--new">
            Would you like to embed media from this site?
            <input class="btn btn-tertiary outline btn-small ml-3" type="button" data-behavior="embed_url" value="Yes, embed it">
          </div>
        </div>
      </div>
      <div class="trix-dialog trix-dialog--link" data-trix-dialog="embed" data-trix-dialog-attribute="embed">
        <div class="trix-dialog__link-fields">
          <input type="text" name="embed" class="trix-input trix-input--dialog" placeholder="Embed" aria-label="Embed html" required data-trix-input>
          <div class="flex">
            <input class="btn btn-secondary btn-small ml-3" type="button" data-behavior="embed_html" value="Embed HTML">
          </div>
        </div>
      </div>
    </div>
  `;
  },
};

// Debug: verify toolbar config is set
if (typeof window !== "undefined") {
  console.log(
    "Trix toolbar config set:",
    typeof Trix.config.toolbar.getDefaultHTML === "function"
  );

  // Update any toolbars that initialize after our config is set
  // This ensures existing editors get the custom toolbar
  document.addEventListener("trix-initialize", (event) => {
    const toolbar = event.target.toolbarElement;
    if (
      toolbar &&
      Trix.config.toolbar &&
      typeof Trix.config.toolbar.getDefaultHTML === "function"
    ) {
      toolbar.innerHTML = Trix.config.toolbar.getDefaultHTML();
    }
  });
}

require("@rails/actiontext");
require("../trix_extensions");

/**
 * Will be extracted and imported with stylesheet_packs_with_chunks_tag 'application'
 */
import "../stylesheets/application.scss";
